<template>
    <new-modal
        :show-close-x="false"
        size="xl"
        ref="takeCatTestModal"
        header-classes="rounded-t border border-primary-900 bg-primary-900 mx-4"
        content-classes="px-0 bg-white"
    >
        <template #trigger>
            <slot/>
        </template>
        <template #header>
            <div class="flex w-full flex-col gap-2 p-6 text-center text-white">
                <div class="text-[20px] font-bold">Take the test</div>
                <div class="text-[16px]">
                    A few things to keep in mind before you start your test
                </div>
            </div>
        </template>
        <template #content>
            <div class="flex flex-col gap-2">
                <div class="flex gap-4 border-b border-gray-300 px-4 py-4">
                    <div
                        class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary-900 text-[16p] text-white"
                    >
                        1
                    </div>
                    <div class="text-[16px]">
                        <span class="font-semibold">During our beta</span>
                        you'll have unlimited attempts to take this test.

                        <!--                        You only have-->
                        <!--                        <span class="font-semibold">1 attempt</span>-->
                        <!--                        to take this test. So make sure you feel ready for the-->
                        <!--                        exam.-->
                    </div>
                </div>
                <div class="flex gap-4 border-b border-gray-300 px-4 py-4">
                    <div
                        class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary-900 text-[16p] text-white"
                    >
                        2
                    </div>
                    <div class="text-[16px]">
                        Since you’re taking the
                        {{ $page.props.auth.user.provider_level.title }}
                        test, you’ll need
                        <span class="font-semibold">
                            <span
                                v-if="
                                    $page.props.auth.user.provider_level
                                        .title === 'EMR'
                                "
                            >1hr 45m</span
                            >
                            <span
                                v-if="
                                    $page.props.auth.user.provider_level
                                        .title === 'EMT'
                                "
                            >2hrs</span
                            >
                            <span
                                v-if="
                                    $page.props.auth.user.provider_level
                                        .title === 'AEMT'
                                "
                            >2hrs 15m</span
                            >
                            <span
                                v-if="
                                    $page.props.auth.user.provider_level
                                        .title === 'Paramedic'
                                "
                            >2hrs 30m</span
                            >
                        </span>
                        of uninterrupted time with a stable internet connection.
                    </div>
                </div>
                <!--                <div class="flex gap-4 border-b border-gray-300 px-4 py-4">-->
                <!--                    <div-->
                <!--                        class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary-900 text-[16p] text-white"-->
                <!--                    >-->
                <!--                        3-->
                <!--                    </div>-->
                <!--                    <div class="text-[16px]">-->
                <!--                        Quitting the test early will-->
                <!--                        <span class="font-semibold">not</span>-->
                <!--                        allow you to take the test over again.-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="flex gap-4 border-b border-gray-300 px-4 py-4">
                    <div
                        class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary-900 text-[16p] text-white"
                    >
                        3
                    </div>
                    <div class="text-[16px]">
                        You cannot go back and edit past questions. Since the
                        exam is adaptive, all questions are based on your
                        answers to previous questions.
                    </div>
                </div>
            </div>
        </template>
        <template #controls>
            <div class="flex w-full justify-end gap-4">
                <div
                    @click="closeModal"
                    class="rounded border border-gray-300 px-3 py-2 hover:cursor-pointer hover:bg-gray-300"
                >
                    Cancel
                </div>
                <div
                    @click="startCatTest"
                    class="rounded border border-primary-525 bg-primary-525 px-3 py-2 text-white hover:cursor-pointer"
                >
                    <span v-if="inProgressCatAttempt"> Resume the test </span>
                    <div v-else>Take the test</div>
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "StudentTakeCatTestModal",
    components: {NewModal},
    props: {
        inProgressCatAttempt: {
            type: Object,
            default: {},
        },
    },
    methods: {
        startCatTest() {
            this.$inertia.get(
                route("student.computer-adaptive-test.start-cat")
            );
        },
        closeModal() {
            this.$refs.takeCatTestModal.closeModal();
        },
    },
};
</script>
